import {Tool} from "types/tool";

export const getToolFromPath = (path: string): Tool | null => {
    if (path.startsWith("/gvef")) return Tool.GVEF;
    if (path.startsWith("/iegp")) return Tool.IEGP;

    return null;
}
